import detailsComponents from "@/app/modules/marketplace/pages/details/product.component.vue";
export default [
  {
    path: "/marketplace",
    name: "Marketplace",
    component: () =>
      import(
        "@/app/modules/marketplace/pages/marketplace/marketplace.component.vue"
      ),
  },

  {
    path: "/marketplace-details",
    name: "Estratégia detalhes",
    components: { default: detailsComponents, details: detailsComponents },
  },

  {
    path: "/marketplace/:partner_name/:extension_id",
    name: "Estratégias de parceiro",
    component: () =>
      import(
        "@/app/modules/marketplace/pages/marketplace/marketplace.component.vue"
      ),
  },

  {
    path: "/marketplace/analistas_xp",
    name: "Analistas XP",
    component: () =>
      import(
        "@/app/modules/marketplace/pages/marketplace/marketplace.component.vue"
      ),
  },

  // TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO
  // TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO
  // TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO
  // TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO TEMPORÁRIO
  {
    path: "/marketplace/heatmap",
    name: "Heatmap",
    component: () =>
      import("@/app/modules/marketplace/pages/heatmap/heatmap.component.vue"),
  },
];
